import React, { cloneElement, Fragment } from "react";
import { useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { setAnsweringQuestionsAction, loadAIDiagnosisQuestionAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const NotEnteredAnswerChecker = ( props ) => {

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };
  const loadAIDiagnosisQuestion = payload => { dispatch( loadAIDiagnosisQuestionAction( payload ) ) };

  const confirm = () => {
    loadAIDiagnosisQuestion( { progressCode : TYPE.ANSWERING_QUESTIONS_PROGRESS.CONTINUE } );
  };

  const hide = () => {
    setAnsweringQuestions( { isShowNotEnteredAnswerPopup : false } );
  };

  return cloneElement( props.children || <Fragment />, {
    onConfirm : confirm,
    onHide : hide
  } );

};

export default NotEnteredAnswerChecker;
